import { render, staticRenderFns } from "./EnableDisableReply.vue?vue&type=template&id=50a805d2&"
import script from "./EnableDisableReply.vue?vue&type=script&lang=js&"
export * from "./EnableDisableReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports